/*
  PYKAS FINDER JS v2 — Scoring-Engine mit Meik-Charakter
  Zweck: 4-Fragen-Stepper mit Fortschritt, Zurück-Button und Meik-Sprechblase (Spruch je Schritt);
  Scoring über die versteckten Sorten-Karten (data-Attribute aus den Section-Blocks):
    +3 Geschmack exakt · +2 Gewässer · +2 Vorhaben · +2 Zielfisch · +Boost (0–3)
  Gewinner-Karte wird in "Meiks Ansage" enthüllt, zweitbester Treffer als Plan B,
  Härtegrad-Tipp je Gewässer. Ohne verfügbare Karten (DRAFT-Produkte): Leer-Ansage.
  DOM-Hooks: [data-pykas-finder], [data-pykas-finder-step], [data-pykas-answer],
  [data-pykas-sorte], [data-pykas-result-slot], [data-pykas-result-planb], [data-pykas-meik-line]
*/

(function () {
  'use strict';

  var STEPS = ['gewaesser', 'ziel', 'frequenz', 'zielfisch', 'geschmack'];

  function initFinder(root) {
    var answers = {};
    var history = [];
    var meikLine = root.querySelector('[data-pykas-meik-line]');
    var progress = root.querySelector('[data-pykas-finder-progress]');
    var backButton = root.querySelector('[data-pykas-finder-back]');
    var result = root.querySelector('[data-pykas-finder-result]');
    var pool = root.querySelector('[data-pykas-sorten-pool]');
    var slot = root.querySelector('[data-pykas-result-slot]');
    var planbWrap = root.querySelector('[data-pykas-result-planb-wrap]');
    var planbSlot = root.querySelector('[data-pykas-result-planb]');
    var tippEl = root.querySelector('[data-pykas-result-tipp]');
    var leerEl = root.querySelector('[data-pykas-finder-leer]');

    function stepEl(name) {
      return root.querySelector('[data-pykas-finder-step="' + name + '"]');
    }

    function showStep(name) {
      STEPS.forEach(function (step) {
        var el = stepEl(step);
        if (el) el.hidden = step !== name;
      });
      if (result) result.hidden = true;
      var index = STEPS.indexOf(name);
      if (progress) {
        progress.hidden = false;
        progress.textContent = 'Frage ' + (index + 1) + ' von ' + STEPS.length;
      }
      var balken = root.querySelector('[data-pykas-finder-balken]');
      if (balken) {
        var pct = Math.round(((index + 1) / STEPS.length) * 100);
        balken.style.width = pct + '%';
        if (balken.parentElement) balken.parentElement.setAttribute('aria-valuenow', String(pct));
      }
      var progressWrap = root.querySelector('[data-pykas-finder-progresswrap]');
      if (progressWrap) progressWrap.hidden = false;
      var neuEl = stepEl(name);
      if (neuEl) {
        neuEl.classList.remove('is-neu'); void neuEl.offsetWidth; neuEl.classList.add('is-neu');
        // A11y: Fokus auf die neue Frage — sonst faellt der Tastaturfokus auf <body> zurueck
        var frage = neuEl.querySelector('h2');
        if (frage) { frage.setAttribute('tabindex', '-1'); frage.focus(); }
      }
      if (backButton) backButton.hidden = index === 0;
      var el = stepEl(name);
      if (meikLine && el && el.dataset.spruch) meikLine.textContent = el.dataset.spruch;
    }

    function scoreCard(card) {
      var score = 0;
      if (card.dataset[answers.gewaesser] === '1') score += 2;
      if (card.dataset[answers.ziel] === '1') score += 2;
      if (card.dataset[answers.zielfisch] === '1') score += 2;
      if (card.dataset.geschmack === answers.geschmack) score += 3;
      score += parseInt(card.dataset.boost, 10) || 0;
      return score;
    }

    function fillSetup() {
      var setup = root.querySelector('[data-pykas-result-setup]');
      if (!setup) return;
      var durchEl = setup.querySelector('[data-pykas-setup-durchmesser]');
      if (durchEl) durchEl.textContent = answers.zielfisch === 'brocken' ? setup.dataset.durchBrocken : setup.dataset.durchAlles;
      var kgKey = 'kg' + (answers.ziel === 'futterplatz' ? 'Futterplatz' : 'Session') + (answers.frequenz === 'oft' ? 'Oft' : answers.frequenz === 'mittel' ? 'Mittel' : 'Selten');
      var kgEl = setup.querySelector('[data-pykas-setup-kg]');
      if (kgEl) kgEl.textContent = setup.dataset[kgKey] || '';
      var kaufartZeile = setup.querySelector('[data-pykas-setup-kaufart-zeile]');
      var kaufartEl = setup.querySelector('[data-pykas-setup-kaufart]');
      if (kaufartZeile && kaufartEl) {
        if (setup.dataset.aboAktiv === 'true') {
          var abo = answers.frequenz === 'oft' || (answers.frequenz === 'mittel' && answers.ziel === 'futterplatz');
          kaufartEl.textContent = abo ? setup.dataset.kaufartAbo : setup.dataset.kaufartEinmal;
          kaufartZeile.hidden = false;
        } else {
          kaufartZeile.hidden = true;
        }
      }
      setup.hidden = false;
    }

    function renderResult() {
      STEPS.forEach(function (step) {
        var el = stepEl(step);
        if (el) el.hidden = true;
      });
      if (progress) progress.hidden = true;
      var wrapEl = root.querySelector('[data-pykas-finder-progresswrap]');
      if (wrapEl) wrapEl.hidden = true;
      if (backButton) backButton.hidden = true;
      var ergebnis = root.querySelector('[data-pykas-finder-result]');
      if (ergebnis) { ergebnis.setAttribute('tabindex', '-1'); ergebnis.focus(); } // pykasFokusErgebnis
      if (result) result.hidden = false;
      fillSetup();

      // vorherige Ergebnisse zurück in den Pool
      if (pool && slot) {
        Array.prototype.slice.call(slot.children).forEach(function (child) { pool.appendChild(child); });
      }
      if (pool && planbSlot) {
        Array.prototype.slice.call(planbSlot.children).forEach(function (child) { pool.appendChild(child); });
      }

      var cards = pool ? Array.prototype.slice.call(pool.querySelectorAll('[data-pykas-sorte]')) : [];
      if (!cards.length) {
        if (leerEl) leerEl.hidden = false;
        if (meikLine) meikLine.textContent = leerEl ? leerEl.textContent : '';
        if (planbWrap) planbWrap.hidden = true;
        if (tippEl) tippEl.hidden = true;
        return;
      }
      if (leerEl) leerEl.hidden = true;

      var ranked = cards
        .map(function (card) { return { card: card, score: scoreCard(card) }; })
        .sort(function (a, b) { return b.score - a.score; });

      var winner = ranked[0].card;
      slot.appendChild(winner);
      winner.hidden = false;

      var spruch = winner.querySelector('.pykas-finder__spruch');
      if (meikLine && spruch) meikLine.textContent = spruch.textContent.trim();

      if (ranked.length > 1 && ranked[1].score > 0) {
        var second = ranked[1].card;
        planbSlot.appendChild(second);
        second.hidden = false;
        planbWrap.hidden = false;
      } else if (planbWrap) {
        planbWrap.hidden = true;
      }

      if (tippEl) {
        var tipp = answers.gewaesser === 'see' ? tippEl.dataset.tippSee : tippEl.dataset.tippFluss;
        tippEl.hidden = !tipp;
        if (tipp) tippEl.textContent = tipp;
      }
    }

    var wechselSperre = false;

    root.querySelectorAll('[data-pykas-answer]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (wechselSperre) return;
        var stepWrap = button.closest('[data-pykas-finder-step]');
        var step = stepWrap.dataset.pykasFinderStep;
        answers[step] = button.dataset.pykasAnswer;
        history.push(step);

        var weiter = function () {
          wechselSperre = false;
          stepWrap.classList.remove('is-beantwortet');
          if (meikLine) meikLine.classList.remove('is-reagiert');
          var nextIndex = STEPS.indexOf(step) + 1;
          if (nextIndex < STEPS.length) {
            showStep(STEPS[nextIndex]);
          } else {
            renderResult();
          }
        };

        // Meiks Reaktion auf genau diese Antwort — kurz zeigen, dann weiter
        var reaktion = button.dataset.reaktion;
        if (reaktion && meikLine) {
          wechselSperre = true;
          meikLine.textContent = reaktion;
          meikLine.classList.add('is-reagiert');
          stepWrap.classList.add('is-beantwortet');
          window.setTimeout(weiter, parseInt(root.dataset.reaktionDauer, 10) || 1600);
        } else {
          weiter();
        }
      });
    });

    if (backButton) {
      backButton.addEventListener('click', function () {
        if (wechselSperre) return;
        var previous = history.pop();
        if (previous) {
          delete answers[previous];
          showStep(previous);
        }
      });
    }

    var restart = root.querySelector('[data-pykas-finder-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        Object.keys(answers).forEach(function (key) { delete answers[key]; });
        history.length = 0;
        if (pool && slot) {
          Array.prototype.slice.call(slot.children).forEach(function (child) { child.hidden = true; pool.appendChild(child); });
        }
        if (pool && planbSlot) {
          Array.prototype.slice.call(planbSlot.children).forEach(function (child) { child.hidden = true; pool.appendChild(child); });
        }
        var startEl = root.querySelector('[data-pykas-finder-step="gewaesser"]');
        if (meikLine && startEl && startEl.dataset.spruch) meikLine.textContent = startEl.dataset.spruch;
        showStep('gewaesser');
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-pykas-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
